import * as React from "react";

import { connect } from "react-redux";

import { Loader, Container } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { ApplicationState } from "../../applicationState";
import { taskSelector } from "../../task/selectors";

import { HavsClinicalAssessmentOfHistoryAndExaminationQuestions } from "./HavsClinicalAssessmentOfHistoryAndExaminationQuestions";

interface StateProps {
    task: TaskModel;
}

const HavsClinicalAssessmentOfHistoryAndExaminationUnconnected: React.FunctionComponent<StateProps> = (props) => {
    if (!props.task) {
        return <Loader />;
    }

    return (
        <Container>
            <HavsClinicalAssessmentOfHistoryAndExaminationQuestions readonly={props.task.completed} />
        </Container>
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => ({
    task: taskSelector(state)
});

export const HavsClinicalAssessmentOfHistoryAndExamination = connect(mapStateToProps)(HavsClinicalAssessmentOfHistoryAndExaminationUnconnected);
